// frontend/src/customLists.js

import httprequest from './../axios';

/**
 * Get all custom lists for the current user
 */
export const getUserLists = async () => {
  try {
    const response = await httprequest.get('/lists');
    return response.data.lists;
  } catch (error) {
    console.error('Error getting user lists:', error);
    return [];
  }
};

/**
 * Create a new custom list
 */
export const createCustomList = async (name, description = '', isGenerated = false, criteria = null) => {
  try {
    const response = await httprequest.post('/lists', {
      name,
      description,
      isGenerated,
      criteria
    });
    return response.data.list;
  } catch (error) {
    console.error('Error creating custom list:', error);
    throw error;
  }
};

/**
 * Update a custom list
 */
export const updateCustomList = async (listId, updates) => {
  try {
    const response = await httprequest.put(`/lists/${listId}`, updates);
    return response.data.list;
  } catch (error) {
    console.error('Error updating custom list:', error);
    throw error;
  }
};

/**
 * Delete a custom list
 */
export const deleteCustomList = async (listId) => {
  try {
    const response = await httprequest.delete(`/lists/${listId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting custom list:', error);
    throw error;
  }
};

/**
 * Get a single custom list with all games
 */
export const getCustomList = async (listId) => {
  try {
    const response = await httprequest.get(`/lists/${listId}`);
    return response.data.list;
  } catch (error) {
    console.error('Error getting custom list:', error);
    return null;
  }
};

/**
 * Add a game to a custom list
 */
export const addGameToList = async (listId, gameId) => {
  try {
    const response = await httprequest.post(`/lists/${listId}/games/${gameId}`);
    return response.data;
  } catch (error) {
    console.error('Error adding game to list:', error);
    throw error;
  }
};

/**
 * Remove a game from a custom list
 */
export const removeGameFromList = async (listId, gameId) => {
  try {
    const response = await httprequest.delete(`/lists/${listId}/games/${gameId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing game from list:', error);
    throw error;
  }
};